import React from 'react'
import { NavLink } from 'react-router-dom'
import { Icon } from '@fluentui/react/lib/Icon'
import NavItem from './sidebar-nav-item'
import { useInternationalization } from '../../features/i18n';

const MapLayers = () => <Icon iconName="MapLayers" className="ms-MapLayers text-xl" />;
const FabricUserFolder = () => <Icon iconName="FabricUserFolder" className="ms-FabricUserFolder text-xl" />;
const Paste = () => <Icon iconName="Paste" className="ms-Paste text-xl" />;
const PenWorkspace = () => <Icon iconName="PenWorkspace" className="ms-PenWorkspace text-xl" />;
const Media = () => <Icon iconName="Media" className="ms-Media text-xl" />;
const OpenFile = () => <Icon iconName="OpenFile" className="ms-OpenFile text-xl" />;
const Settings = () => <Icon iconName="Settings" className="ms-Settings text-xl" />;
const DoubleBookmark = () => <Icon iconName="DoubleBookmark" className="ms-DoubleBookmark text-xl" />;

const Sidebar = ({children, role, onChange}) => {
  const { translate } = useInternationalization()
  const menu = [
    {
      name: 'dashboard',
      label: translate('NAVIGATION', 'dashboard'),
      route: '/dashboard',
      icon: <MapLayers />,
      roles: ['official'],
      exact: true
    },
    {
      name: 'profile',
      label: translate('DASHBOARD', 'my_profile'),
      route: '/dashboard/profile',
      icon: <FabricUserFolder />,
      roles: ['verified', 'user']
    },
    {
      name: 'profile',
      label: translate('ORGANIZATION', 'profile'),
      route: '/dashboard/organization/profile/',
      icon: <FabricUserFolder />,
      roles: ['official']
    },
    {
      name: 'bookmarks',
      label: translate('BOOKMARK', 'plural'),
      route: {
        pathname: '/dashboard/bookmarks',
        state: {
          title: 'Bookmarks',
        }
      },
      icon: <DoubleBookmark />,
      roles: ['verified', 'user']
    },
    {
      name: 'tickets',
      label: translate('DASHBOARD', 'event_tickets'),
      route: '/dashboard/tickets',
      icon: <Paste />,
      roles: ['verified']
    },
    {
      name: 'programs',
      label: translate('PROGRAM', 'our'),
      route: {
        pathname: '/dashboard/programs',
        state: {
          title: translate('PROGRAM', 'our'),
          createRoute: {
            pathname: '/dashboard/programs/create',
            state: {
              title: translate('PROGRAM', 'create'),
            }
          }
        }
      },
      icon: <Paste />,
      roles: ['official']
    },
    {
      name: 'events',
      label: translate('EVENT', 'our'),
      route: {
        pathname: '/dashboard/events',
        state: {
          title: translate('EVENT', 'our'),
          createRoute: {
            pathname: '/dashboard/events/create',
            state: {
              title: translate('EVENT', 'create'),
            }
          }
        }
      },
      icon: <PenWorkspace />,
      roles: ['official'],
      // unread: true
    },
    {
      name: 'resources',
      label: translate('RESOURCE', 'our'),
      route: {
        pathname: '/dashboard/resources',
        state: {
          title: translate('RESOURCE', 'our'),
          createRoute: {
            pathname: '/dashboard/resources/create',
            state: {
              title: translate('RESOURCE', 'create'),
            }
          }
        }
      },
      icon: <Media />,
      roles: ['official']
    },
    {
      name: 'blog',
      label: translate('BLOG', 'our'),
      route: {
        pathname: '/dashboard/blog',
        state: {
          title: translate('BLOG', 'our'),
          createRoute: {
            pathname: '/dashboard/blog/create',
            state: {
              title: translate('BLOG', 'create'),
            }
          }
        }
      },
      icon: <OpenFile />,
      roles: ['official']
    },
    {
      name: 'visibility',
      label: translate('VISIBILITY', 'default'),
      route: {
        pathname: '/dashboard/visibility',
        state: {
          title: translate('VISIBILITY', 'default'),
        }
      },
      icon: <Settings />,
      roles: ['official']
    },
    {
      name: 'settings',
      label: translate('DASHBOARD', 'account_settings'),
      route: {
        pathname: '/dashboard/settings',
        state: {
          title: translate('DASHBOARD', 'account_settings'),
        }
      },
      icon: <Settings />,
      roles: ['official', 'verified', 'user']
    },
  ]

  const menuFilteredByRole = menu.filter(m => m.roles.indexOf(role) > -1)

  return (
    <div>
      {
        menuFilteredByRole &&
        menuFilteredByRole.map((m, i) => (
          <NavLink exact={m.exact} className="dashboard-nav-link" to={m.route} key={i} onClick={onChange}>
            <NavItem data={m}/>
          </NavLink>
        ))
      }
      {children}
    </div>
  )
}

export { Sidebar }
